import React from 'react';
import ServiceItem from '../components/elements/service_item';
import CTA from '../components/sections/cta';
import '../assets/css/pages/services.css';
import service1 from '../assets/images/service1.png';
import service2 from '../assets/images/service2.png';
import service3 from '../assets/images/service3.png';
import service4 from '../assets/images/service4.png';
// import service5 from '../assets/images/service5.png';
import hero from '../assets/images/feature_bg.png';

const Services = () => {
    const services = [
        {
            image: service1,
            title: "Real-time Monitoring Solutions",
            features: [
                "24/7 water quality monitoring",
                "AI-powered analytics",
                "Instant alerts and notifications",
                "Historical data tracking"
            ],
            serviceName: "Monitoring Solutions",
            buttonText: "Learn More",
            variant: "red"
        },
        {
            image: service2,
            title: "Aquaculture Health Management",
            features: [
                "Disease prevention systems",
                "Health assessment tools",
                "Treatment recommendations",
                "Population health tracking"
            ],
            serviceName: "Health Management",
            buttonText: "Explore Services",
            variant: "yellow"
        },
        {
            image: service3,
            title: "Expert Consulting Services",
            features: [
                "Facility optimization",
                "System setup guidance",
                "Operation assessment",
                "Performance improvement"
            ],
            serviceName: "Consulting Services",
            buttonText: "Get Started",
            variant: "red"
        },
        {
            image: service4,
            title: "Training & Education",
            features: [
                "Staff training programs",
                "Best practices workshops",
                "Technical certification",
                "Ongoing support"
            ],
            serviceName: "Training Programs",
            buttonText: "Join Program",
            variant: "yellow"
        }
    ];

    return (
        <div className="services-page">
            <h1>COMPREHENSIVE SOLUTIONS FOR YOUR AQUACULTURE NEEDS</h1>
            <div className="hero-section">
                <img 
                    src={hero} 
                    alt="Aquaculture Services" 
                    className="hero-image"
                />
                <div className="hero-content">
                    {/* <h1>Our Services</h1> */}
                    <p>At E-AquaHealth, we understand the unique challenges of fish farming. That is why we’ve designed a platform that is more than just a service provider- it’s a partner in your success. Our advanced diagnostic tools, expert support network...
                        From water quality management to disease prevention, we offer expert solutions to optimize your aquaculture operations. Our comprehensive services ensure the health and productivity of your aquatic systems.</p>
                </div>
            </div>

            <div className="services-container">
                {services.map((service, index) => (
                    <ServiceItem 
                        key={index}
                        {...service}
                    />
                ))}
            </div>

            &nbsp;
            <br/>

            <CTA />
        </div>
    );
};

export default Services;